import React from 'react';
import {useTranslation} from 'react-i18next';

const doctors = [
  {
    key: 'sumenko',
    image: 'assets/img/images/about-us/Sumenko.jpg',
  },
  {
    key: 'roswora',
    image: 'assets/img/images/about-us/Roswora.jpg',
  },
  {
    key: 'yenilmez',
    image: 'assets/img/images/about-us/Yenilmez.jpg',
  },
];

const AboutDoctors = () => {
  const {t} = useTranslation();

  return (
    <section id="about-us" className="block spacer p-top-xl">
      {doctors.map((doctor) => {
        const paragraphs = t(`about_me_page.doctors.${doctor.key}.description`, {
          returnObjects: true,
        });

        return (
          <article key={doctor.key} className="about-doctor">
            <div className="row gutter-width-sm align-items-start about-doctor-row">
              <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                <div className="about-doctor-media">
                  <div className="img object-fit">
                    <div className="object-fit-cover">
                      <img
                        src={doctor.image}
                        alt={t(`about_me_page.doctors.${doctor.key}.name`)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12">
                <div className="about-doctor-content">
                  <h2 className="about-doctor-name">
                    {t(`about_me_page.doctors.${doctor.key}.name`)}
                  </h2>
                  {(Array.isArray(paragraphs) ? paragraphs : []).map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </div>
          </article>
        );
      })}
    </section>
  );
};

export default AboutDoctors;
